import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from './message';

import reportService from '../services/report.service';



export const fetchInwardPackingReport = createAsyncThunk(
    'report/fetchInwardPackingReport',
    async (params, thunkAPI) => {
        try {
            // Destructure and pass all params in correct order
            const { start_date, end_date, page, pagesize, search, ordering } = params;
            const response = await reportService.getInwardPackingReport(start_date, end_date, page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

export const fetchWorkorderReport = createAsyncThunk(
    'report/fetchWorkorderReport',
    async ({ start_date, end_date, page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await reportService.getWorkorderReport(start_date, end_date, page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

export const fetchInwardPackingDateWiseReport = createAsyncThunk(
    'report/fetchInwardPackingDateWiseReport',
    async ({ from_date, to_date, page, pagesize, search, groupId, ordering, }, thunkAPI) => {
        try {
            const response = await reportService.getInwardPackingDateWiseReport(from_date, to_date, page, pagesize, search, groupId, ordering,);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

export const fetchOutwardPackingDateWiseReport = createAsyncThunk(
    'report/fetchOutwardPackingDateWiseReport',
    async ({ from_date, to_date, page, pagesize, search, groupId, ordering, }, thunkAPI) => {
        try {
            const response = await reportService.getOutwardPackingDateWiseReport(from_date, to_date, page, pagesize, search, groupId, ordering,);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);


const initialState = {
    data: [],
    list: [],
    totalRecord: 0,
    totalPages: 0,
    currentPage: 1,
    hasMore: false,
    status: 'idle',
    loading: false,
    Workorderdata: [],
    WorkordertotalRecord: 0,
    WorkordertotalPages: 0,
    WorkordercurrentPage: 0,
    Workorderlist: [],
    PackingDateWisedata: [],
    PackingDateWiseRecord: 0,
    PackingDateWisePages: 0,
    PackingDateWisePage: 0,
    PackingDateWiselist: [],
    OutwardDateWisedata: [],
    OutwardDateWiseRecord: 0,
    OutwardDateWisePages: 0,
    OutwardDateWisePage: 0,
    OutwardDateWiselist: [],
};



const reportSlice = createSlice({
    name: 'reportSlice',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetInwardPackingReportData: (state) => {
            state.data = []; // This will clear the list
        },
        resetInwardPackingReportList: (state) => {
            state.list = []; // This will clear the list
        },
        resetInwardPackingCurrentReportPage: (state) => {
            state.currentPage = 1;
        },
        resetWorkorderReportData: (state) => {
            state.Workorderdata = []; // This will clear the list
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchInwardPackingReport.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchInwardPackingReport.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchInwardPackingReport.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });


        builder
            .addCase(fetchWorkorderReport.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchWorkorderReport.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.Workorderdata = action.payload.data || [];  // Update to match your API response
                state.WorkordertotalRecord = action.payload.count || 0; // Handle count (total records)
                state.WorkordertotalPages = action.payload.totalPages || 0; // Handle totalPages
                state.WorkordercurrentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.Workorderlist = [...state.Workorderlist, ...action.payload.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchWorkorderReport.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });

        builder
            .addCase(fetchInwardPackingDateWiseReport.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchInwardPackingDateWiseReport.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.PackingDateWisedata = action.payload.data || [];  // Update to match your API response
                state.PackingDateWiseRecord = action.payload.count || 0; // Handle count (total records)
                state.PackingDateWisePages = action.payload.totalPages || 0; // Handle totalPages
                state.PackingDateWisePage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.PackingDateWiselist = [...state.PackingDateWiselist, ...action.payload.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchInwardPackingDateWiseReport.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });

        builder
            .addCase(fetchOutwardPackingDateWiseReport.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchOutwardPackingDateWiseReport.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.OutwardDateWisedata = action.payload.data || [];  // Update to match your API response
                state.OutwardDateWiseRecord = action.payload.count || 0; // Handle count (total records)
                state.OutwardDateWisePages = action.payload.totalPages || 0; // Handle totalPages
                state.OutwardDateWisePage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.OutwardDateWiselist = [...state.OutwardDateWiselist, ...action.payload.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchOutwardPackingDateWiseReport.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });


    },
});

export const { resetReportData, resetReportList, resetCurrentReportPage, resetWorkorderReportData } = reportSlice.actions;
export default reportSlice.reducer;